import mutations from './eprofileAutonomia.mutations'
import actions from './eprofileAutonomia.actions'
import getters from './eprofileAutonomia.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
